import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOrder Types */
import {
  Settings,
  _SupplierOrder
} from '../namespace-helper'

import _ from 'lodash'

// selected item template
const selectedSupplierOrderTemplate = {
  id: 0,
  purchase_orders_id: 0,
  procurements_status_id: 0,
  purchase_order: {
    customers_id: 0
  },
  documents_id: 0,
  suppliers_orders_proforma: {
    payment_term_percent: ''
  },
  messages_id: 0
}

export default {
  namespaced: true,
  state: {
    supplierOrders: [],
    selectedSupplierOrder: _.cloneDeep(selectedSupplierOrderTemplate),
    openDialog: false,
    creatingSupplierOrders: false
  },
  mutations: {
    [_SupplierOrder.mutations.setSupplierOrders] (state, payload) {
      state.supplierOrders = payload
    },
    [_SupplierOrder.mutations.setSelectedSupplierOrder] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOrder = payload
      } else {
        state.selectedSupplierOrder = _.cloneDeep(selectedSupplierOrderTemplate)
      }
    },
    [_SupplierOrder.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    },
    [_SupplierOrder.mutations.setCreatingSupplierOrder] (state, payload) {
      state.creatingSupplierOrders = payload
    }
  },
  actions: {
    [_SupplierOrder.actions.saveSupplierOrder] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOrders'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOrders/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            store.commit(Settings.mutations.setLoading, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOrder.actions.loadSupplierOrders] (context, payload) {
      console.log('loadSupplierOrders: ' + JSON.stringify(payload))
      console.log('loadSupplierOrders: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/supplierOrders?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'purchase_orders_number:like;' +
                'procurement.purchaseOrder.customer_purchase_order_number:like;' +
                'procurement.purchaseOrder.purchase_orders_number:like;' +
                'procurement.purchaseOrder.account.firstname:like;' +
                'suppliersOrdersStatus.name:like' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_SupplierOrder.mutations.setSupplierOrders, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_SupplierOrder.actions.loadSupplierOrdersForProcurement] (context, payload) {
      console.log('loadSupplierOrdersForProcurement: ' + JSON.stringify(payload))
      console.log('loadSupplierOrdersForProcurement: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/supplierOrders/procurement/ ' + payload.id + '?limit=' + payload.limit +
                '&page=' + payload.page +
                '&search=' + payload.search +
                '&searchFields=id:like;' +
                'purchase_orders_number:like;' +
                'procurement.purchaseOrder.customer_purchase_order_number:like;' +
                'procurement.purchaseOrder.purchase_orders_number:like;' +
                'procurement.purchaseOrder.account.firstname:like;' +
                'suppliersOrdersStatus.name:like' +
                '&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        console.log('loadedOffers: ' + JSON.stringify(r.data.data))
        context.commit(_SupplierOrder.mutations.setSupplierOrders, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    /*    [_SupplierOrder.actions.loadSupplierOrder] (context, payload) {
              console.log('loadProcurement: ' + JSON.stringify(payload))

              var url = API_URL + '/api/v1/procurements/' + payload.id
              return new Promise((resolve, reject) => {
                axios.get(url, {
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + store.getters.getBearerToken
                  }
                }
                    ).then(function (r) {
                      ErrorHandler.clear(store)
                      resolve(r)
                    }, function (err) {
                      ErrorHandler.handleApiError(store, err)
                      reject(err)
                    }).catch(e => console.error('#### ' + e))
              })
            }, */
    [_SupplierOrder.actions.sendSupplierOrder] (context, payload) {
      console.log('sendSupplierOrder: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/supplierOrders/' + payload.id + '/sendSupplierOrder'

      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        return axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.openCloseDialog] ({ commit }) {
      commit(_SupplierOrder.mutations.setOpenCloseDialogState)
    },
    [_SupplierOrder.actions.setSelectedSupplierOrder] ({ commit }, payload) {
      commit(_SupplierOrder.mutations.setSelectedSupplierOrder, payload)
    },
    [_SupplierOrder.actions.reloadSelectedPurchaseOrder] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      var url = API_URL + '/api/v1/supplierOrders/' + payload
      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOrder.mutations.setSelectedSupplierOrder, r.data.data)
          resolve(r)
        }, function (err) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.loadStatuses] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/supplierOrderStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.createSupplierOrder] (context, payload) {
      context.commit(_SupplierOrder.mutations.setCreatingSupplierOrder, true)

      const data = JSON.stringify(payload)
      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/supplierOrders/createSupplierOrders'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOrder.mutations.setCreatingSupplierOrder, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOrder.mutations.setCreatingSupplierOrder, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.deleteSupplierOrder] (context, payload) {
      var url = API_URL + '/api/v1/supplierOrders/' + payload.id

      console.log('deleteOrderPositions: ' + payload.id)

      store.commit(Settings.mutations.setLoading, true)

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.loadSupplierOrderById] (context, payload) {
      console.log('loadSupplierOrderById: ' + JSON.stringify(payload))
      var url = API_URL + '/api/v1/supplierOrders/' + payload

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrder.actions.resetState] ({ commit }, payload) {
      commit(_SupplierOrder.mutations.setSupplierOrders, [])
      commit(_SupplierOrder.mutations.setSelectedSupplierOrder, null)
    }
  },
  getters: {
    [_SupplierOrder.getters.supplierOrders] (state) {
      return state.supplierOrders
    },
    [_SupplierOrder.getters.getOpenDialogState] (state) {
      return state.openDialog
    },
    [_SupplierOrder.getters.getSelectedSupplierOrder] (state) {
      return state.selectedSupplierOrder
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOrder/supplierOrders.js